import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm-1.5-8.5V8h3v3.5h-3Zm1.46 1.056c-1.33 0-3.96.638-3.96 1.944V16h8v-1.5c0-1.306-2.711-1.944-4.04-1.944Z" }));
export default createSvgIcon(iconPath, "Impersonation");
//# sourceMappingURL=StatusImpersonationIcon.js.map